import React from "react";
import Title from "../home/Title";
import ResumeTitle from "../resume/ResumeTitle";

const Skills = () => {
  return (
    <section id="resume">
      <Title title="My" subTitle="Skills" />
      <div className="w-full grid grid-cols-1 px-8">
        <div className="w-full">
          <ResumeTitle title="Programming Languages" />
          <div className="py-4">
            <div className="py-3 border-b-[1px] border-zinc-800">
              <div className="flex justify-between items-center">
                <p className="text-base text-textColor -mb-1.5">Python</p>
                <p className="text-base text-textColor -mb-1.5">95%</p>
              </div>
              <span className="w-full bg-zinc-600 h-1 inline-flex relative">
                <span className="w-[95%] h-full absolute top-0 left-0 bg-designColor"></span>
              </span>
            </div>
            <div className="py-3 border-b-[1px] border-zinc-800">
              <div className="flex justify-between items-center">
                <p className="text-base text-textColor -mb-1.5">JavaScript</p>
                <p className="text-base text-textColor -mb-1.5">95%</p>
              </div>
              <span className="w-full bg-zinc-600 h-1 inline-flex relative">
                <span className="w-[95%] h-full absolute top-0 left-0 bg-designColor"></span>
              </span>
            </div>
            <div className="py-3 border-b-[1px] border-zinc-800">
              <div className="flex justify-between items-center">
                <p className="text-base text-textColor -mb-1.5">SQL</p>
                <p className="text-base text-textColor -mb-1.5">90%</p>
              </div>
              <span className="w-full bg-zinc-600 h-1 inline-flex relative">
                <span className="w-[90%] h-full absolute top-0 left-0 bg-designColor"></span>
              </span>
            </div>
          </div>
        </div>
        <div className="col-span-9 md:col-span-4 ">
          <ResumeTitle title="Frontend Development" />
          <div className="py-4">
            <div className="py-3 border-b-[1px] border-zinc-800">
              <div className="flex justify-between items-center">
                <p className="text-base text-textColor -mb-1.5">React.js</p>
                <p className="text-base text-textColor -mb-1.5">95%</p>
              </div>
              <span className="w-full bg-zinc-600 h-1 inline-flex relative">
                <span className="w-[95%] h-full absolute top-0 left-0 bg-designColor"></span>
              </span>
            </div>
            <div className="py-3 border-b-[1px] border-zinc-800">
              <div className="flex justify-between items-center">
                <p className="text-base text-textColor -mb-1.5">Next.js</p>
                <p className="text-base text-textColor -mb-1.5">95%</p>
              </div>
              <span className="w-full bg-zinc-600 h-1 inline-flex relative">
                <span className="w-[95%] h-full absolute top-0 left-0 bg-designColor"></span>
              </span>
            </div>
            <div className="py-3 border-b-[1px] border-zinc-800">
              <div className="flex justify-between items-center">
                <p className="text-base text-textColor -mb-1.5">Vue.js</p>
                <p className="text-base text-textColor -mb-1.5">90%</p>
              </div>
              <span className="w-full bg-zinc-600 h-1 inline-flex relative">
                <span className="w-[90%] h-full absolute top-0 left-0 bg-designColor"></span>
              </span>
            </div>
            <div className="py-3 border-b-[1px] border-zinc-800">
              <div className="flex justify-between items-center">
                <p className="text-base text-textColor -mb-1.5">Angular.js</p>
                <p className="text-base text-textColor -mb-1.5">85%</p>
              </div>
              <span className="w-full bg-zinc-600 h-1 inline-flex relative">
                <span className="w-[85%] h-full absolute top-0 left-0 bg-designColor"></span>
              </span>
            </div>
            <div className="py-3 border-b-[1px] border-zinc-800">
              <div className="flex justify-between items-center">
                <p className="text-base text-textColor -mb-1.5">React Native</p>
                <p className="text-base text-textColor -mb-1.5">90%</p>
              </div>
              <span className="w-full bg-zinc-600 h-1 inline-flex relative">
                <span className="w-[90%] h-full absolute top-0 left-0 bg-designColor"></span>
              </span>
            </div>
            <div className="py-3 border-b-[1px] border-zinc-800">
              <div className="flex justify-between items-center">
                <p className="text-base text-textColor -mb-1.5">GatsbyJS</p>
                <p className="text-base text-textColor -mb-1.5">85%</p>
              </div>
              <span className="w-full bg-zinc-600 h-1 inline-flex relative">
                <span className="w-[85%] h-full absolute top-0 left-0 bg-designColor"></span>
              </span>
            </div>
          </div>
        </div>
        <div className="col-span-9 md:col-span-4 ">
          <ResumeTitle title="Backend Development" />
          <div className="py-4">
            <div className="py-3 border-b-[1px] border-zinc-800">
              <div className="flex justify-between items-center">
                <p className="text-base text-textColor -mb-1.5">Node.js</p>
                <p className="text-base text-textColor -mb-1.5">90%</p>
              </div>
              <span className="w-full bg-zinc-600 h-1 inline-flex relative">
                <span className="w-[90%] h-full absolute top-0 left-0 bg-designColor"></span>
              </span>
            </div>
            <div className="py-3 border-b-[1px] border-zinc-800">
              <div className="flex justify-between items-center">
                <p className="text-base text-textColor -mb-1.5">Flask</p>
                <p className="text-base text-textColor -mb-1.5">90%</p>
              </div>
              <span className="w-full bg-zinc-600 h-1 inline-flex relative">
                <span className="w-[90%] h-full absolute top-0 left-0 bg-designColor"></span>
              </span>
            </div>
            <div className="py-3 border-b-[1px] border-zinc-800">
              <div className="flex justify-between items-center">
                <p className="text-base text-textColor -mb-1.5">FastAPI</p>
                <p className="text-base text-textColor -mb-1.5">90%</p>
              </div>
              <span className="w-full bg-zinc-600 h-1 inline-flex relative">
                <span className="w-[90%] h-full absolute top-0 left-0 bg-designColor"></span>
              </span>
            </div>
            <div className="py-3 border-b-[1px] border-zinc-800">
              <div className="flex justify-between items-center">
                <p className="text-base text-textColor -mb-1.5">Prisma.js</p>
                <p className="text-base text-textColor -mb-1.5">90%</p>
              </div>
              <span className="w-full bg-zinc-600 h-1 inline-flex relative">
                <span className="w-[90%] h-full absolute top-0 left-0 bg-designColor"></span>
              </span>
            </div>
          </div>
        </div>
        <div className="col-span-9 md:col-span-4 ">
          <ResumeTitle title="CSS Frameworks" />
          <div className="py-4">
            <div className="py-3 border-b-[1px] border-zinc-800">
              <div className="flex justify-between items-center">
                <p className="text-base text-textColor -mb-1.5">Tailwind CSS</p>
                <p className="text-base text-textColor -mb-1.5">95%</p>
              </div>
              <span className="w-full bg-zinc-600 h-1 inline-flex relative">
                <span className="w-[95%] h-full absolute top-0 left-0 bg-designColor"></span>
              </span>
            </div>
            <div className="py-3 border-b-[1px] border-zinc-800">
              <div className="flex justify-between items-center">
                <p className="text-base text-textColor -mb-1.5">Bootstrap CSS</p>
                <p className="text-base text-textColor -mb-1.5">95%</p>
              </div>
              <span className="w-full bg-zinc-600 h-1 inline-flex relative">
                <span className="w-[95%] h-full absolute top-0 left-0 bg-designColor"></span>
              </span>
            </div>
            <div className="py-3 border-b-[1px] border-zinc-800">
              <div className="flex justify-between items-center">
                <p className="text-base text-textColor -mb-1.5">Sass CSS</p>
                <p className="text-base text-textColor -mb-1.5">90%</p>
              </div>
              <span className="w-full bg-zinc-600 h-1 inline-flex relative">
                <span className="w-[90%] h-full absolute top-0 left-0 bg-designColor"></span>
              </span>
            </div>
          </div>
        </div>
        <div className="col-span-9 md:col-span-4 ">
          <ResumeTitle title="Databases" />
          <div className="py-4">
            <div className="py-3 border-b-[1px] border-zinc-800">
              <div className="flex justify-between items-center">
                <p className="text-base text-textColor -mb-1.5">MySQL</p>
                <p className="text-base text-textColor -mb-1.5">95%</p>
              </div>
              <span className="w-full bg-zinc-600 h-1 inline-flex relative">
                <span className="w-[95%] h-full absolute top-0 left-0 bg-designColor"></span>
              </span>
            </div>
            <div className="py-3 border-b-[1px] border-zinc-800">
              <div className="flex justify-between items-center">
                <p className="text-base text-textColor -mb-1.5">MongoDB</p>
                <p className="text-base text-textColor -mb-1.5">90%</p>
              </div>
              <span className="w-full bg-zinc-600 h-1 inline-flex relative">
                <span className="w-[90%] h-full absolute top-0 left-0 bg-designColor"></span>
              </span>
            </div>
            <div className="py-3 border-b-[1px] border-zinc-800">
              <div className="flex justify-between items-center">
                <p className="text-base text-textColor -mb-1.5">PostgreSQL</p>
                <p className="text-base text-textColor -mb-1.5">90%</p>
              </div>
              <span className="w-full bg-zinc-600 h-1 inline-flex relative">
                <span className="w-[90%] h-full absolute top-0 left-0 bg-designColor"></span>
              </span>
            </div>
            <div className="py-3 border-b-[1px] border-zinc-800">
              <div className="flex justify-between items-center">
                <p className="text-base text-textColor -mb-1.5">Firebase</p>
                <p className="text-base text-textColor -mb-1.5">85%</p>
              </div>
              <span className="w-full bg-zinc-600 h-1 inline-flex relative">
                <span className="w-[85%] h-full absolute top-0 left-0 bg-designColor"></span>
              </span>
            </div>
            <div className="py-3 border-b-[1px] border-zinc-800">
              <div className="flex justify-between items-center">
                <p className="text-base text-textColor -mb-1.5">DynamoDB</p>
                <p className="text-base text-textColor -mb-1.5">85%</p>
              </div>
              <span className="w-full bg-zinc-600 h-1 inline-flex relative">
                <span className="w-[85%] h-full absolute top-0 left-0 bg-designColor"></span>
              </span>
            </div>
          </div>
        </div>
        <div className="col-span-9 md:col-span-4 ">
          <ResumeTitle title="Cloud & DevOps" />
          <div className="py-4">
            <div className="py-3 border-b-[1px] border-zinc-800">
              <div className="flex justify-between items-center">
                <p className="text-base text-textColor -mb-1.5">AWS</p>
                <p className="text-base text-textColor -mb-1.5">90%</p>
              </div>
              <span className="w-full bg-zinc-600 h-1 inline-flex relative">
                <span className="w-[90%] h-full absolute top-0 left-0 bg-designColor"></span>
              </span>
            </div>
            <div className="py-3 border-b-[1px] border-zinc-800">
              <div className="flex justify-between items-center">
                <p className="text-base text-textColor -mb-1.5">Docker</p>
                <p className="text-base text-textColor -mb-1.5">85%</p>
              </div>
              <span className="w-full bg-zinc-600 h-1 inline-flex relative">
                <span className="w-[85%] h-full absolute top-0 left-0 bg-designColor"></span>
              </span>
            </div>
            <div className="py-3 border-b-[1px] border-zinc-800">
              <div className="flex justify-between items-center">
                <p className="text-base text-textColor -mb-1.5">CI/CD</p>
                <p className="text-base text-textColor -mb-1.5">90%</p>
              </div>
              <span className="w-full bg-zinc-600 h-1 inline-flex relative">
                <span className="w-[90%] h-full absolute top-0 left-0 bg-designColor"></span>
              </span>
            </div>
            <div className="py-3 border-b-[1px] border-zinc-800">
              <div className="flex justify-between items-center">
                <p className="text-base text-textColor -mb-1.5">GitHub Actions</p>
                <p className="text-base text-textColor -mb-1.5">90%</p>
              </div>
              <span className="w-full bg-zinc-600 h-1 inline-flex relative">
                <span className="w-[90%] h-full absolute top-0 left-0 bg-designColor"></span>
              </span>
            </div>
            <div className="py-3 border-b-[1px] border-zinc-800">
              <div className="flex justify-between items-center">
                <p className="text-base text-textColor -mb-1.5">DigitalOcean</p>
                <p className="text-base text-textColor -mb-1.5">85%</p>
              </div>
              <span className="w-full bg-zinc-600 h-1 inline-flex relative">
                <span className="w-[85%] h-full absolute top-0 left-0 bg-designColor"></span>
              </span>
            </div>
            <div className="py-3 border-b-[1px] border-zinc-800">
              <div className="flex justify-between items-center">
                <p className="text-base text-textColor -mb-1.5">Cloudflare</p>
                <p className="text-base text-textColor -mb-1.5">85%</p>
              </div>
              <span className="w-full bg-zinc-600 h-1 inline-flex relative">
                <span className="w-[85%] h-full absolute top-0 left-0 bg-designColor"></span>
              </span>
            </div>
          </div>
        </div>
        <div className="col-span-9 md:col-span-4 ">
          <ResumeTitle title="Data Mining" />
          <div className="py-4">
            <div className="py-3 border-b-[1px] border-zinc-800">
              <div className="flex justify-between items-center">
                <p className="text-base text-textColor -mb-1.5">Beautiful Soup</p>
                <p className="text-base text-textColor -mb-1.5">95%</p>
              </div>
              <span className="w-full bg-zinc-600 h-1 inline-flex relative">
                <span className="w-[95%] h-full absolute top-0 left-0 bg-designColor"></span>
              </span>
            </div>
            <div className="py-3 border-b-[1px] border-zinc-800">
              <div className="flex justify-between items-center">
                <p className="text-base text-textColor -mb-1.5">Selenium</p>
                <p className="text-base text-textColor -mb-1.5">90%</p>
              </div>
              <span className="w-full bg-zinc-600 h-1 inline-flex relative">
                <span className="w-[90%] h-full absolute top-0 left-0 bg-designColor"></span>
              </span>
            </div>
          </div>
        </div>
        <div className="col-span-9 md:col-span-4 ">
          <ResumeTitle title="ML, AI & Data Science" />
          <div className="py-4">
            <div className="py-3 border-b-[1px] border-zinc-800">
              <div className="flex justify-between items-center">
                <p className="text-base text-textColor -mb-1.5">Machine Learning</p>
                <p className="text-base text-textColor -mb-1.5">90%</p>
              </div>
              <span className="w-full bg-zinc-600 h-1 inline-flex relative">
                <span className="w-[90%] h-full absolute top-0 left-0 bg-designColor"></span>
              </span>
            </div>
            <div className="py-3 border-b-[1px] border-zinc-800">
              <div className="flex justify-between items-center">
                <p className="text-base text-textColor -mb-1.5">Deep Learning</p>
                <p className="text-base text-textColor -mb-1.5">90%</p>
              </div>
              <span className="w-full bg-zinc-600 h-1 inline-flex relative">
                <span className="w-[90%] h-full absolute top-0 left-0 bg-designColor"></span>
              </span>
            </div>
            <div className="py-3 border-b-[1px] border-zinc-800">
              <div className="flex justify-between items-center">
                <p className="text-base text-textColor -mb-1.5">Data Analysis</p>
                <p className="text-base text-textColor -mb-1.5">90%</p>
              </div>
              <span className="w-full bg-zinc-600 h-1 inline-flex relative">
                <span className="w-[90%] h-full absolute top-0 left-0 bg-designColor"></span>
              </span>
            </div>
            <div className="py-3 border-b-[1px] border-zinc-800">
              <div className="flex justify-between items-center">
                <p className="text-base text-textColor -mb-1.5">Power BI</p>
                <p className="text-base text-textColor -mb-1.5">85%</p>
              </div>
              <span className="w-full bg-zinc-600 h-1 inline-flex relative">
                <span className="w-[85%] h-full absolute top-0 left-0 bg-designColor"></span>
              </span>
            </div>
            <div className="py-3 border-b-[1px] border-zinc-800">
              <div className="flex justify-between items-center">
                <p className="text-base text-textColor -mb-1.5">EDA</p>
                <p className="text-base text-textColor -mb-1.5">90%</p>
              </div>
              <span className="w-full bg-zinc-600 h-1 inline-flex relative">
                <span className="w-[90%] h-full absolute top-0 left-0 bg-designColor"></span>
              </span>
            </div>
          </div>
        </div>
        <div className="col-span-9 md:col-span-4 ">
          <ResumeTitle title="Other Tools" />
          <div className="py-4">
            <div className="py-3 border-b-[1px] border-zinc-800">
              <div className="flex justify-between items-center">
                <p className="text-base text-textColor -mb-1.5">Git/GitLab</p>
                <p className="text-base text-textColor -mb-1.5">95%</p>
              </div>
              <span className="w-full bg-zinc-600 h-1 inline-flex relative">
                <span className="w-[95%] h-full absolute top-0 left-0 bg-designColor"></span>
              </span>
            </div>
            <div className="py-3 border-b-[1px] border-zinc-800">
              <div className="flex justify-between items-center">
                <p className="text-base text-textColor -mb-1.5">Postman</p>
                <p className="text-base text-textColor -mb-1.5">90%</p>
              </div>
              <span className="w-full bg-zinc-600 h-1 inline-flex relative">
                <span className="w-[90%] h-full absolute top-0 left-0 bg-designColor"></span>
              </span>
            </div>
            <div className="py-3 border-b-[1px] border-zinc-800">
              <div className="flex justify-between items-center">
                <p className="text-base text-textColor -mb-1.5">VS Code</p>
                <p className="text-base text-textColor -mb-1.5">95%</p>
              </div>
              <span className="w-full bg-zinc-600 h-1 inline-flex relative">
                <span className="w-[95%] h-full absolute top-0 left-0 bg-designColor"></span>
              </span>
            </div>
            <div className="py-3 border-b-[1px] border-zinc-800">
              <div className="flex justify-between items-center">
                <p className="text-base text-textColor -mb-1.5">WordPress</p>
                <p className="text-base text-textColor -mb-1.5">85%</p>
              </div>
              <span className="w-full bg-zinc-600 h-1 inline-flex relative">
                <span className="w-[85%] h-full absolute top-0 left-0 bg-designColor"></span>
              </span>
            </div>
            <div className="py-3 border-b-[1px] border-zinc-800">
              <div className="flex justify-between items-center">
                <p className="text-base text-textColor -mb-1.5">cPanel</p>
                <p className="text-base text-textColor -mb-1.5">85%</p>
              </div>
              <span className="w-full bg-zinc-600 h-1 inline-flex relative">
                <span className="w-[85%] h-full absolute top-0 left-0 bg-designColor"></span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
